import {
  ChevronLeftIcon,
  ChevronDoubleLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon
} from '@heroicons/react/outline'
function Pagination (props) {
  return (
    <div className="pagination pt-4 flex items-center justify-between">
      <div>
        <span className={`text-sm ${props.tableTheme.pageColor}`}>
          Page 
          <strong className={`${props.tableTheme.pageColor} font-medium px-1`}>{props.pageIndex + 1}</strong>
          of
          <strong className={`${props.tableTheme.pageColor} font-medium px-1`}>{props.pageOptions.length}</strong>
        </span>
        {/* 选择一页显示几条数据 */}
        <select className={`${props.tableTheme.pageColor} ${props.tableTheme.pageSelectBgColor} text-sm py-1 border rounded-sm border-gray-300 ml-2`}
          value={props.pageSize}
          onChange={e => {
            props.setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize} className={`${props.tableTheme.pageColor} ${props.tableTheme.pageSelectBgColor}`}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
      
      {/* 快速跳转到某页 */}
      {/* <span>
        | Go to page:
        <input
          type="number"
          defaultValue={props.pageIndex + 1}
          onChange={e => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0
            props.gotoPage(page)
          }}
          style={{ width: '100px' }}
        />
      </span> */}

      {props.children}
       
      <ul className="inline-flex items-center -space-x-px">
        <li className={`
            block ${props.tableTheme.nextPageBgcolor} border border-gray-300 rounded-l-lg leading-tight py-1 px-2
            ${props.canPreviousPage ? 'cursor-pointer hover:text-gray-700 hover:bg-gray-100 text-gray-400' : 'cursor-not-allowed text-gray-300'}
            `}
          onClick={() => props.gotoPage(props.pageIndex - 5 < 0 ? 0 : props.pageIndex - 5)}
          disabled={!props.canPreviousPage}
        >
          <ChevronDoubleLeftIcon className={`h-6 ${props.tableTheme.pageColor}`}/>
        </li>
        <li className={`
            block ${props.tableTheme.nextPageBgcolor} border border-gray-300 leading-tight py-1 px-2
            ${props.canPreviousPage ? 'cursor-pointer hover:text-gray-700 hover:bg-gray-100 text-gray-400' : 'cursor-not-allowed text-gray-300'}
          `}
          onClick={() => props.previousPage()}
          disabled={!props.canPreviousPage}
        >
          <ChevronLeftIcon className={`h-6 ${props.tableTheme.pageColor}`}/>
        </li>
        <li  className={`
            block ${props.tableTheme.nextPageBgcolor} border border-gray-300 leading-tight py-1 px-2
            ${props.canNextPage ? 'cursor-pointer hover:text-gray-700 hover:bg-gray-100 text-gray-400' : 'cursor-not-allowed text-gray-300'}
          `}
          onClick={() => props.nextPage()}
          disabled={!props.canNextPage}
        >
          <ChevronRightIcon className={`h-6 ${props.tableTheme.pageColor}`}/>
        </li>
        <li className={`
            block ${props.tableTheme.nextPageBgcolor} border border-gray-300 rounded-r-lg leading-tight py-1 px-2
            ${props.canNextPage ? 'cursor-pointer hover:text-gray-700 hover:bg-gray-100 text-gray-400' : 'cursor-not-allowed text-gray-300'}
          `}
          onClick={() => props.gotoPage(props.pageIndex + 5 > props.pageOptions.length - 1 ? props.pageOptions.length - 1 : props.pageIndex + 5)}
          disabled={!props.canNextPage}
        >
          <ChevronDoubleRightIcon className={`h-6 ${props.tableTheme.pageColor}`}/>
        </li>
        </ul>
    </div>
  )
}
export default Pagination